import { defaultFill } from '../utils/constants';
var muiTruthmark16 = {
    paths: [
        {
            path: 'M8.00511623,0.0262736842 C3.5861661,0.0262736842 0.00429473684,3.61802766 0.00429473684,8.04916993 C0.00429473684,12.1938979 3.13805303,15.6032 7.1597383,16.0262737 L11.4126208,11.4675123 L11.4126208,15.7346211 L16.0042947,15.7346211 L16.0042947,8.04916993 C16.0042947,3.61802766 12.4223812,0.0262736842 8.00511623,0.0262736842 L8.00511623,0.0262736842 Z M11.4125786,11.4675123 L7.99926047,11.4675123 C6.11488539,11.4675123 4.58766954,9.93439298 4.58766954,8.04418514 C4.58766954,6.15456872 6.11488539,4.6222943 7.99926047,4.6222943 C9.88452023,4.6222943 11.4125786,6.15456872 11.4125786,8.04418514 L11.4125786,11.4675123 Z',
            fill: defaultFill,
        },
    ],
    title: 'Truthmark',
    width: 17,
    height: 16,
};
var muiTruthmark24 = {
    paths: [
        {
            path: 'M12.0012632,0.0394105263 C5.37637895,0.0394105263 0.00644210526,5.40934737 0.00644210526,12.0342316 C0.00644210526,18.2309053 4.70456842,23.3280632 10.7338737,23.9605895 L17.1097895,17.1449053 L17.1097895,23.5245474 L23.9936211,23.5245474 L23.9936211,12.0342316 C23.9936211,5.40934737 18.6236211,0.0394105263 12.0012632,0.0394105263 L12.0012632,0.0394105263 Z M17.1097263,17.1449053 L11.9924842,17.1449053 C9.16743158,17.1449053 6.87783158,14.8527789 6.87783158,12.0267789 C6.87783158,9.20166316 9.16743158,6.9108 11.9924842,6.9108 C14.8188632,6.9108 17.1097263,9.20166316 17.1097263,12.0267789 L17.1097263,17.1449053 Z',
            fill: defaultFill,
        },
    ],
    title: 'Truthmark',
    width: 24,
    height: 24,
};
var muiTruthmark = {
    base: muiTruthmark16,
    smIcon: muiTruthmark16,
    lgIcon: muiTruthmark24,
};
export { muiTruthmark };
//# sourceMappingURL=truthmark.js.map